import { Component, computed, inject, Input, input } from '@angular/core';
import { UserService } from '../../user.service';
import { ViewSetting } from '../../global/global-interfaces';
import { SizeService } from '../../size-detection/size.service';

@Component({
  selector: 'sb-view-setting',
  templateUrl: './view-setting.component.html',
  styleUrls: ['./view-setting.component.scss'],
  standalone: false,
})
export class ViewSettingComponent {
  private readonly userService = inject(UserService);
  protected readonly sizeService = inject(SizeService);

  @Input({ required: true }) itemName: string;
  currentViewSetting = input.required<{ view: ViewSetting; default: boolean }>();
  isDefaultMode = computed<boolean>(() => {
    return this.currentViewSetting().default;
  });

  setViewSetting(mode: ViewSetting) {
    if (!mode) {
      throw Error('No ViewSetting mode provided');
    }

    if (mode && (mode === 'list' || mode === 'card')) {
      this.userService.setUserSetting(this.itemName + 'ViewSetting', mode).then(() => {});
    } else {
      this.resetViewSetting();
    }
  }

  resetViewSetting(): void {
    this.userService.clearUserSetting(this.itemName + 'ViewSetting').then(() => {});
  }
}
